function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r)
    i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;
else {
    var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); };
    o("next", 0), o("throw", 1), o("return", 2);
} }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import React, { useRef } from 'react';
import Drawer from './components/Drawer';
import Home from './pages/Home';
import { ThemeProvider } from '@mui/material';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useIdleTimer } from 'react-idle-timer';
import { Settings, ProductSelection } from './pages';
import { AuthorizationAPI } from './apis';
import { ConfigProvider } from './components/ConfigContext';
import ErrorBoundary from './components/ErrorBoundary';
import Toast, { handleErrorModal } from './components/Toast';
import { ToastContextProvider } from './components/ToastContext';
import './styles/globals.css';
import { theme } from './styles/theme';
import Product from './pages/Product';
import Cookies from 'js-cookie';
import useBeaconScript from './hooks/useBeaconScript';
import useDocumentTitle from './hooks/useDocumentTitle';
import TermsOfUse from './components/TermsOfUse';
export default function App() {
    var _process$env$REACT_AP;
    useBeaconScript();
    useDocumentTitle();
    var navigate = useNavigate();
    var timeout = 60 * 60 * 1000; // 1 hour timeout
    var throttle = 10 * 60 * 1000; // 10 minute throttle
    var refreshPromise = null;
    var isFirstAction = useRef(true);
    var performTokenRefresh = /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.n) {
                        case 0:
                            if (!refreshPromise) {
                                refreshPromise = AuthorizationAPI.refreshToken().then(function (result) {
                                    if (result !== null && result !== void 0 && result.accessToken) {
                                        Cookies.set('access_token', result.accessToken, {
                                            secure: true,
                                            sameSite: 'Strict'
                                        });
                                        Cookies.set('refresh_token', result.refreshToken, {
                                            secure: true,
                                            sameSite: 'Strict'
                                        });
                                    }
                                    return result;
                                })["finally"](function () {
                                    refreshPromise = null;
                                });
                            }
                            return _context.a(2, refreshPromise);
                    }
            }, _callee);
        }));
        return function performTokenRefresh() {
            return _ref.apply(this, arguments);
        };
    }();
    var onIdle = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.n) {
                        case 0:
                            handleErrorModal(true, 'You were logged out due to inactivity.');
                            _context2.n = 1;
                            return AuthorizationAPI.logout();
                        case 1:
                            navigate('/');
                        case 2:
                            return _context2.a(2);
                    }
            }, _callee2);
        }));
        return function onIdle() {
            return _ref2.apply(this, arguments);
        };
    }();
    var onAction = /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
            var result;
            return _regenerator().w(function (_context3) {
                while (1)
                    switch (_context3.n) {
                        case 0:
                            if (!isFirstAction.current) {
                                _context3.n = 1;
                                break;
                            }
                            isFirstAction.current = false;
                            return _context3.a(2);
                        case 1:
                            _context3.n = 2;
                            return performTokenRefresh();
                        case 2:
                            result = _context3.v;
                            if (!(result !== null && result !== void 0 && result.accessToken)) {
                                _context3.n = 3;
                                break;
                            }
                            activate(); // reset the idle timer
                            _context3.n = 5;
                            break;
                        case 3:
                            _context3.n = 4;
                            return AuthorizationAPI.logout();
                        case 4:
                            navigate('/');
                        case 5:
                            return _context3.a(2);
                    }
            }, _callee3);
        }));
        return function onAction() {
            return _ref3.apply(this, arguments);
        };
    }();
    var _useIdleTimer = useIdleTimer({
        onIdle: onIdle,
        onAction: onAction,
        onActive: onAction,
        timeout: timeout,
        throttle: throttle
    }), activate = _useIdleTimer.activate;
    return /*#__PURE__*/ React.createElement(ErrorBoundary, null, /*#__PURE__*/ React.createElement(ConfigProvider, null, /*#__PURE__*/ React.createElement(ThemeProvider, {
        theme: theme
    }, /*#__PURE__*/ React.createElement(ToastContextProvider, null, /*#__PURE__*/ React.createElement(Routes, null, /*#__PURE__*/ React.createElement(Route, {
        path: "/",
        element: /*#__PURE__*/ React.createElement(Home, null)
    }), JSON.parse((_process$env$REACT_AP = process.env.REACT_APP_false) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : 'false') && /*#__PURE__*/ React.createElement(Route, {
        path: "/productSelection",
        element: /*#__PURE__*/ React.createElement(Drawer, null, /*#__PURE__*/ React.createElement(ProductSelection, null))
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/:product/*",
        element: /*#__PURE__*/ React.createElement(Drawer, null, /*#__PURE__*/ React.createElement(Product, null))
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/settings",
        element: /*#__PURE__*/ React.createElement(Drawer, null, /*#__PURE__*/ React.createElement(Settings, null))
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/terms-of-use",
        element: /*#__PURE__*/ React.createElement(Drawer, null, /*#__PURE__*/ React.createElement(TermsOfUse, null))
    })), /*#__PURE__*/ React.createElement(Toast, null)))));
}
